import React, { ReactNode } from "react";
import cx from "classnames";

import styles from "./Heading.module.scss";

interface Props {
  variant: "h1" | "h2" | "h3" | "h4" | "h5" | "h6",
  children: ReactNode,
  className?: string,
  mt?: number,
  mb?: number,
};

export function Heading({ children, variant, className, mt, mb }: Props) {
  return (
    <p
      className={cx(styles.Heading, className, {
        [styles.h1]: variant === "h1",
        [styles.h2]: variant === "h2",
        [styles.h3]: variant === "h3",
        [styles.h4]: variant === "h4",
        [styles.h5]: variant === "h5",
        [styles.h6]: variant === "h6",
      })}
      style={{
        marginTop: mt ? `${mt}px` : 0,
        marginBottom: mb ? `${mb}px` : 0,
      }}
    >
      {children}
    </p>
  );
}

